<template>
  <div class="activity-view">
    <ActivityList :for="'customer'"
                  :actions-to-hide-details-button="['mark_collected','unmark_collected','cancelled.invoice', 'unpaid.invoice', 'create.customer_logo']"
                  :actions="actions"
                  :value-visualizer="valueVisualizer">
      <template v-slot:text="{activity}">
        <span v-if="actions[activity.action]">
          <template v-if="typeof actions[activity.action].message === 'function'">
            {{ actions[activity.action].message(activity) }}
          </template>
          <template v-else>
            {{ actions[activity.action].message }}
          </template>
        </span>
        <span v-else>
          {{ activity.action }}
        </span>
      </template>
      <template slot="modal-body(update.invoice_miscellaneous_items)" slot-scope="{activity}">
        <activity-miscellaneous-table :activity="activity"/>
      </template>
    </ActivityList>
  </div>
</template>

<script>
  import ActivityList from "../../../activities/ActivityList";
  import {createNamespacedHelpers} from "vuex";
  import customerActivityHelper from './customerActivityHelper';
  import ActivityMiscellaneousTable from "@/modules/receipt/view/activities/ActivityMiscellaneousTable";

  const {mapActions: activityMapActions} = createNamespacedHelpers('activities');

  const {mapState} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "ActivitiesView",
    components: {ActivityList, ActivityMiscellaneousTable},
    data: () => {
      return {
        actions: customerActivityHelper.actions
      };
    },
    computed: {
      ...mapState(['customer']),
    },
    methods: {
      ...activityMapActions(['setActivitiesParams']),
      valueVisualizer: customerActivityHelper.valueVisualizer
    },
    beforeMount() {
      this.setActivitiesParams({
        object: this.customer,
        source: 'customer',
        excludeActivities: ['create.tax_status', 'create.payment_terms', 'create.commissions']
      })
    }
  }
</script>

<style lang="scss">
</style>
